<template>
  <svg
      v-if="slash"
      class="lp-none-mark is-slash"
      viewBox="0 0 24 24"
      aria-hidden="true">
    <rect
        x="2.5"
        y="2.5"
        width="19"
        height="19"
        rx="4"
        fill="#fff"
        stroke="#D0D4DA"/>
    <path
        d="M5 19L19 5"
        stroke="#E5484D"
        stroke-width="1.8"
        stroke-linecap="round"/>
  </svg>
  <svg
      v-else
      class="lp-none-mark"
      viewBox="0 0 24 24"
      aria-hidden="true">
    <circle
        cx="12"
        cy="12"
        r="7.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"/>
    <path
        d="M6.8 17.2L17.2 6.8"
        stroke="currentColor"
        stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name:  'NoneMark',
  props: {
    slash: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-none-mark {
  width: 20px;
  height: 20px;
  color: $lp-muted;

  &.is-slash {
    width: 26px;
    height: 26px;
  }
}
</style>
